import { createContext, useState } from "react";

export const GetData = createContext();

export const GetDataProvider = ({ children }) => {
    const [message, setMessage] = useState(false);
    return <GetData.Provider value={[message, setMessage]}>{children}</GetData.Provider>;
};
